import { createRoutine } from 'redux-saga-routines';

export const fetchVisitColumns = createRoutine('FETCH_VISIT_COLUMNS');

export const fetchVisitOrderByTrackingMethods = createRoutine(
  'FETCH_VISIT_ORDER_BY_TRACKING_METHODS'
);
export const fetchVisitConfigs = createRoutine('FETCH_VISIT_CONFIGS');
